// Vorys retargeting landing add-to-cart handler.
(function () {
  'use strict';

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
  }

  function trackLandingEvent(eventName, data) {
    if (typeof clarity === 'function') {
      clarity('event', eventName);
      Object.keys(data || {}).forEach(function (key) {
        if (data[key]) clarity('set', key, String(data[key]));
      });
    }

    if (eventName === 'paid_landing_add_to_cart' && typeof fbq === 'function') {
      fbq('track', 'AddToCart', {
        content_ids: [data.variant_id],
        content_type: 'product',
        source: 'retargeting_landing'
      });
    }
  }

  async function addToCart(variantId, ctaLabel) {
    var utmContent = getParam('utm_content');
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          _landing: 'akilli-gozluk',
          _utm_content: utmContent,
          _cta: ctaLabel
        }
      })
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    trackLandingEvent('paid_landing_add_to_cart', {
      variant_id: variantId,
      utm_content: utmContent,
      cta: ctaLabel
    });

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.location.href = '/cart';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-variant-id]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = button.getAttribute('data-original-text') || button.textContent;
    button.setAttribute('data-original-text', originalText);
    button.disabled = true;
    button.textContent = 'Sepete ekleniyor...';

    addToCart(variantId, button.id || 'paid-landing-cta').catch(function (error) {
      console.error('Vorys cart add failed', error);
      button.disabled = false;
      button.textContent = originalText;
      window.alert('Sepete eklenemedi. Lütfen birkaç saniye sonra tekrar deneyin.');
    });
  });

  function toggleStickyCta() {
    var sticky = document.querySelector('.paid-sticky-cta');
    if (!sticky) return;

    var heroButton = document.querySelector('#paid-hero-cta');
    var showAfter = heroButton
      ? heroButton.getBoundingClientRect().bottom < 0
      : window.scrollY > window.innerHeight * 0.6;

    sticky.classList.toggle('is-visible', showAfter);
    sticky.setAttribute('aria-hidden', showAfter ? 'false' : 'true');
  }

  window.addEventListener('scroll', toggleStickyCta, { passive: true });
  window.addEventListener('resize', toggleStickyCta);
  toggleStickyCta();

  trackLandingEvent('paid_landing_view', {
    page_type: 'paid_landing',
    utm_content: getParam('utm_content')
  });
})();
